import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { agenda } from '../data/site';
export function Agenda() {
  const [activeId, setActiveId] = useState(agenda[0].id);
  const activeDay = agenda.find(day => day.id === activeId) ?? agenda[0];
  return <section id="agenda" className="bg-forest-deep py-24 sm:py-28" data-id="element-21" data-mp="5270eeo23ela">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-22" data-mp="11r4vxz3mrgji">
        <SectionHeading eyebrow="Event agenda" title="Two days of insights, connections, and Texas BBQ." align="center" data-id="element-23" data-mp="11osd7jq1t25e" />

        <div role="tablist" aria-label="Agenda days" className="mx-auto mt-12 flex w-full max-w-xl gap-2 rounded-full border border-forest-line bg-forest p-1.5" data-id="element-24" data-mp="sovmlck3lt7p">
          {agenda.map(day => {
          const selected = day.id === activeId;
          return <button key={day.id} role="tab" id={`tab-${day.id}`} aria-selected={selected} aria-controls={`panel-${day.id}`} onClick={() => setActiveId(day.id)} className="relative flex-1 rounded-full px-4 py-3 text-center text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cream" data-id="element-25" data-mp="38frl7pe4r9wj">
                {selected && <motion.span layoutId="agenda-pill" transition={{
              type: 'spring',
              stiffness: 380,
              damping: 32
            }} className="absolute inset-0 rounded-full bg-cream" data-id="element-26" data-mp="h41se14buipm" />}
                <span className={`relative block font-medium ${selected ? 'text-forest' : 'text-cream-dim'}`} data-id="element-27" data-mp="c5zz6nd6t30f">
                  {day.date}
                </span>
                <span className={`relative mt-0.5 block text-[11px] ${selected ? 'text-forest/60' : 'text-cream-muted'}`} data-id="element-28" data-mp="34a5tbzqvu00">
                  {day.label}
                </span>
              </button>;
        })}
        </div>

        <AnimatePresence mode="wait" data-id="element-29" data-mp="1w2z1qcox9wwt">
          <motion.ol key={activeDay.id} id={`panel-${activeDay.id}`} role="tabpanel" aria-labelledby={`tab-${activeDay.id}`} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.28,
          ease: 'easeOut'
        }} className="mx-auto mt-12 max-w-3xl border-l border-forest-line pl-6 sm:pl-10" data-id="element-30" data-mp="1vzt8qmd6aavt">
            {activeDay.items.map(item => <li key={`${item.time}-${item.title}`} className="relative pb-10 last:pb-0" data-id="element-31" data-mp="13di7ralnm7yh">
                <span aria-hidden="true" className="absolute -left-[29px] top-1.5 h-2.5 w-2.5 rounded-full bg-cream/50 ring-4 ring-forest-deep sm:-left-[45px]" data-id="element-32" data-mp="yef4nvp8ibt5" />
                <p className="text-xs uppercase tracking-widest2 text-cream-muted" data-id="element-33" data-mp="t9bleesfhg54">
                  {item.time}
                </p>
                <h3 className="mt-2 font-display text-xl text-cream" data-id="element-34" data-mp="y7wc9nlsingw">
                  {item.title}
                </h3>
                {item.body && <p className="mt-1.5 text-sm leading-relaxed text-cream-dim" data-id="element-35" data-mp="170zvkcj49ujg">
                    {item.body}
                  </p>}
              </li>)}
          </motion.ol>
        </AnimatePresence>
      </div>
    </section>;
}